<template>
  <ion-page>
    <ion-header class="ion-no-border">
      <ion-toolbar>
        <ion-buttons slot="start">
          <back-button
            :defaultHref="{ name: 'home' }"
            :icon="require('@lib/assets/icons/icon_zurueck.svg')"
            text=""
          >
          </back-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content ref="content" class="ion-padding">
      <ion-grid fixed>
        <ErklaerungZTK :from="from" />
        <ion-row class="ion-margin-top">
          <ion-col>
            <div class="c-nugget u-bg-orange">
              <div
                class="c-nugget__image"
                :style="{
                  'background-image':
                    'url(' + require('@/assets/img/content/podcast.svg') + ')',
                }"
              ></div>
              <div class="c-nugget__label">
                Podcast
              </div>
            </div>
          </ion-col>
          <ion-col>
            <div class="c-nugget u-bg-orange">
              <div
                class="c-nugget__image"
                :style="{
                  'background-image':
                    'url(' +
                    require('@/assets/img/home/icon_roodie_video.svg') +
                    ')',
                }"
              >
                <img src="@/assets/img/play.svg" />
              </div>
              <div class="c-nugget__label">
                Erklärungsvideo
              </div>
            </div>
          </ion-col>
        </ion-row>
        <!-- <div class="c-iframe ion-margin-top">
          <div class="c-iframe__wrapper">
            <iframe
              class="c-iframe__video"
              width="560"
              height="315"
              src="https://www.youtube.com/embed/6bXoqniCoGc"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </div>
        </div> -->
        <!-- <ion-row class="ion-margin-top">
          <ion-col size="12">
            <div
              class="c-nugget u-bg-orange"
              @click="$router.push({ path: '/ztk/anleitung_notbot' })"
            >
              <div
                class="c-nugget__image"
                :style="{
                  'background-image':
                    'url(' +
                    require('@/assets/img/content/icon_roodie_call.svg') +
                    ')',
                }"
              ></div>
              <div class="c-nugget__label">
                So funktioniert's
              </div>
            </div>
          </ion-col>
          <ion-col>
            <div
              class="c-nugget u-bg-orange"
              @click="
                $router.push({
                  name: 'datenschutz',
                  params: { routing: 'ZTK' },
                })
              "
            >
              <div
                class="c-nugget__image"
                :style="{
                  'background-image':
                    'url(' +
                    require('@/assets/img/content/browser-anfrage.svg') +
                    ')',
                }"
              ></div>
              <div class="c-nugget__label">
                Termin anfragen
              </div>
            </div>
          </ion-col>
          <ion-col>
            <div
              class="c-nugget u-bg-orange"
              @click="
                $router.push({
                  name: 'datenschutz',
                  params: { routing: 'ZTK' },
                })
              "
            >
              <div
                class="c-nugget__image"
                :style="{
                  'background-image':
                    'url(' +
                    require('@/assets/img/content/browser-buchen.svg') +
                    ')',
                }"
              ></div>
              <div class="c-nugget__label">
                Termin buchen
              </div>
            </div>
          </ion-col>
        </ion-row> -->
        <!-- <ion-row class="ion-margin-top">
          <ion-col size="auto">
            <ion-icon :src="require('@lib/assets/icons/info.svg')" />
          </ion-col>
          <ion-col>
            <ion-text color="primary">
              Das Angebot der Zahnärztlichen Tageskliniken ist eine
              Zusatzleistung des Kooperationspartners. Sie kann jederzeit
              entfallen, wenn die Kooperation endet.
            </ion-text>
          </ion-col>
        </ion-row> -->
      </ion-grid>
    </ion-content>
  </ion-page>
</template>

<script>
import { chevronBack } from "ionicons/icons";
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonContent,
  IonButton,
  IonIcon,
  IonButtons,
  IonGrid,
  IonRow,
  IonCol,
  IonBackButton,
  // IonText,
} from "@ionic/vue";
import ErklaerungZTK from "@/components/ErklaerungZTK";

export default {
  components: {
    IonPage,
    IonHeader,
    IonToolbar,
    IonContent,
    IonButton,
    IonIcon,
    IonButtons,
    IonGrid,
    IonRow,
    IonCol,
    ErklaerungZTK,
    IonBackButton,
    // IonText,
  },
  // props: {
  //   from: {
  //     type: String,
  //     required: false,
  //     default: "",
  //   },
  // },
  data() {
    return {
      from: "",
    };
  },
  ionViewWillEnter() {
    this.from = this.$route?.params?.from;
  },
  setup() {
    return {
      chevronBack,
    };
  },
};
</script>

<style lang="scss" scoped></style>
